import { BrokerDto, TaskDto } from '@maia/shared';
import { Pagination, Select, ToggleButtonGroup } from '@maia/ui';
import { Tasks } from '../../task/tasks/queryOptions';
import { EditableTaskWidget } from '@maia/ui';

type tasksListProps = {
  tasks: Tasks;
  me: BrokerDto;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  setFilter: (assignee: string) => void;
  setSorting: (sorting: string) => void;
  onBrokerChange: (task: TaskDto, broker: BrokerDto) => void;
  onPriorityChange: (task: TaskDto, priority: string) => void;
  onStatusChange: (task: TaskDto, status: string) => void;
  activeFilter?: string;
  activeSorting?: string;
  brokers: BrokerDto[];
};

export function TasksList(props: tasksListProps) {
  const {
    tasks,
    setPage,
    setLimit,
    setFilter,
    setSorting,
    activeFilter,
    activeSorting,
    brokers,
    onBrokerChange,
    onPriorityChange,
    onStatusChange,
  } = props;

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <div>
        <div className="flex gap-x-24">
          <ToggleButtonGroup
            defaultSelectedKey={activeFilter ?? ''}
            items={[
              { label: 'Alles', value: '' },
              {
                label: 'Mijn taken',
                value: 'my_tasks',
              },
              {
                label: 'Niet toegewezen',
                value: 'unassigned',
              },
            ]}
            onChange={setFilter}
          />
          <Select
            className="ml-auto"
            enforceMaxHeight
            onChange={(value) => setSorting(value.toString())}
            placeholder="Selecteren"
            defaultSelectedKey={activeSorting ?? 'most_recent'}
            items={[
              {
                label: 'Meest recent',
                value: 'most_recent',
                meta: {},
              },
              {
                label: 'Hoogste prioriteit',
                value: 'highest_priority',
                meta: {},
              },
              {
                label: 'Laagste prioriteit',
                value: 'lowest_priority',
                meta: {},
              },
              {
                label: 'Verlooptijd',
                value: 'duration',
                meta: {},
              },
            ]}
          />
        </div>
      </div>
      <ul className="flex flex-col gap-y-12 w-full">
        {tasks.response.map((task) => (
          <li id={task.guid} key={task.guid}>
            <EditableTaskWidget
              task={task}
              brokers={brokers}
              onBrokerChange={(brokerGuid) => {
                const broker = brokerGuid
                  ? brokers.find((broker) => broker.guid === brokerGuid)
                  : {
                      guid: '',
                      firstName: '',
                      lastName: '',
                    };
                return onBrokerChange(task, broker as BrokerDto);
              }}
              onPriorityChange={(priority) => onPriorityChange(task, priority)}
              onStatusChange={(status) => onStatusChange(task, status)}
            />
          </li>
        ))}
      </ul>
      <Pagination
        {...tasks.pagination}
        onLimitChange={setLimit}
        onPageChange={setPage}
        variant="borderless"
      />
    </div>
  );
}
